import { useHistory } from "react-router-dom";

import useVarParam from "./use-var-param";
import { checkUser } from "utils";

const { getUserPermissions } = checkUser;



const useAuthRedirect = () => {

    const history = useHistory(),
        guestParams = useVarParam("guest"),
        { hasActiveEvent } = checkUser;

    return ({ user }) => {

        const comeFrom = guestParams.get("comeFrom");

        const isStandRoute = comeFrom && comeFrom.startsWith('/stands/');

        const { hasViewNotRelatedPermission } = getUserPermissions(user);

        if (isStandRoute && hasViewNotRelatedPermission)
        {
            return history.replace(comeFrom);
        }

        if (!hasActiveEvent(user) && !hasViewNotRelatedPermission)
        {
            return history.replace("/exhibitions");
        }

        if (comeFrom)
        {
            return history.replace(comeFrom);
        }

        return history.replace("/");
    };

}

export default useAuthRedirect;